import script from "./PreferredLocations.vue?vue&type=script&lang=ts&setup=true"
export * from "./PreferredLocations.vue?vue&type=script&lang=ts&setup=true"

import "./PreferredLocations.vue?vue&type=style&index=0&id=2b681569&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b681569"]])

export default __exports__